//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import $ from "jquery";
import { mapState, mapActions } from "vuex";
import AnnouncementBar from "./partials/AnnouncementBar.vue";
import PageHeader from "./partials/PageHeader.vue";
import PageFooter from "./partials/PageFooter.vue";

import PageHeaderPlain from "./partials/PageHeaderPlain.vue";
import PageFooterPlain from "./partials/PageFooterPlain.vue";
import PageHeaderPlainDark from "./partials/PageHeaderPlainDark.vue";
import PageFooterPlainDark from "./partials/PageFooterPlainDark.vue";

import PageHeaderBurstConversr from "./partials/PageHeaderBurstConversr.vue";

import PageHeaderBlackFriday from "./partials/PageHeaderBlackFriday.vue";
import PageFooterBlackFriday from "./partials/PageFooterBlackFriday.vue";
import PageHeaderLogo from "./partials/PageHeaderLogo.vue";
import PageHeaderBurstConversrLogoWhite from "./partials/PageHeaderBurstConversrLogoWhite.vue";
import PageHeaderBurstConversrLogoWhiteRight from "./partials/PageHeaderBurstConversrLogoWhiteRight.vue";

export default {
    scrollToTop: true,
    head() {
        const link = [
            {
                rel: "alternate",
                hreflang: "en-us",
                href: ("https://burstsms.com" + this.$nuxt.$route.path).toString().replace(/^(.+?)\/*?$/, "$1") + "/",
            },
        ];

        if (this.page.slug === "index") {
            link.push({
                rel: "prefetch",
                href: "/uploads/home_texture_white.svg",
            });
            link.push({
                rel: "prefetch",
                href: "/uploads/home-hero-image.svg",
            });

            for (let i = 0; i <= 14; i++) {
                link.push({
                    rel: "preload",
                    as: "image",
                    href: "https://assets4.lottiefiles.com/packages/lf20_8telucjr/images/img_" + i + "." + ([10, 14].includes(i) ? "jpg" : "png") + "",
                });
            }
        }

        return {
            link,
        };
    },
    data() {
        return {
            scrolled: false,
            lastScrollTop: 0,
            lastScrollDelta: 0,
            scrollingTimeout: null,
        };
    },
    components: {
        AnnouncementBar,
        PageHeader,
        PageFooter,
        PageHeaderPlain,
        PageFooterPlain,
        PageHeaderPlainDark,
        PageFooterPlainDark,
        PageHeaderBlackFriday,
        PageFooterBlackFriday,
        PageHeaderBurstConversr,
        PageHeaderLogo,
        PageHeaderBurstConversrLogoWhite,
        PageHeaderBurstConversrLogoWhiteRight,
    },
    computed: {
        ...mapState({
            page: (state) => state.pages.page,
        }),
        layout() {
            return this.page.layout || "default";
        },
        otherClasses() {
            const classes = [];
            const refreshedPages = ["index", "two-factor-authentication", "customer-service", "sms-alerts-and-notifications", "sms-reminders", "not-for-profit", "sms-for-healthcare", "operations", "sms-marketing", "quick-sms-launcher"];

            if (this.page.scrolled) classes.push("layout--scrolled");
            if (this.page.scrolled && this.page.scrolling) classes.push("scrolling--" + this.page.scrolling);

            if (refreshedPages.includes(this.page.slug) && this.page.layout === "default") classes.push("page--refresh");

            classes.push("sticky-" + (this.page.sticky ? "on" : "off"));

            return classes.join(" ");
        },
    },
    methods: {
        ...mapActions({
            scroll: "pages/scroll",
        }),
    },
    created() {
        if (process.browser) {
            // history.scrollRestoration = "manual";
            // window.onbeforeunload = function () {
            //   window.scrollTo(0, 0);
            // }

            const self = this;

            $(function () {
                // $(window).scroll(function(event){
                //   console.log(event);
                // });

                self.scrolled = $(window).scrollTop() > 127;
                let lastDownDelta = 0;
                let lastUpDelta = 0;

                $(window).scroll(function () {
                    self.scrolled = $(this).scrollTop() > 127;

                    if (self.scrollingTimeout) clearTimeout(self.scrollingTimeout);
                    const st = $(this).scrollTop();

                    let scrolled = false;
                    let scrolling = false;
                    let sticky = false;
                    const scrollDelta = st - self.lastScrollTop;

                    if (st > 127) {
                        scrolled = true;
                        if (scrollDelta > 0) {
                            scrolling = "down";
                            sticky = false;
                            lastDownDelta = st;
                        } else {
                            lastUpDelta = st;
                            if (lastDownDelta - lastUpDelta > 300) {
                                scrolling = "up";
                                sticky = true;
                            }
                        }
                    } else {
                        scrolled = false;
                    }

                    self.lastScrollTop = st;

                    const $scrollSection = document.querySelector('[data-section="accordion-scroll"]');

                    if ($scrollSection) {
                        if (st >= $scrollSection.offsetTop && st <= $scrollSection.offsetTop + ($scrollSection.clientHeight - window.innerHeight)) {
                            sticky = false;
                        }
                    }

                    // if($(window).width() < 992)
                    sticky = true;

                    self.scroll({
                        sticky,
                        scrolled,
                        scrolling,
                    });
                });
            });
        }
    },
};
